<template>
    <div class="card">
        <div class="card__title">
            <h6><b>{{ title }}</b></h6>
            <div v-show="imagenes.length > 0" class="card__controls">
                <button @click="copiarLinks" class="btn-light btn--text" type="button"><i class="fa fa-link"></i> <span>{{ $t('message.copiarLinks') }}</span></button>
                <button @click="descargarGrupo" class="btn-primary" type="button"><i class="fa fa-download"></i><span>{{ $t('message.descargarTodo') }}</span></button>
            </div>
        </div>
        <div v-show="imagenes.length > 0" class="card__content">
            <div class="card__content px-0">
                <div class="carrousel">
                    <div v-for="(imagen, index) in imagenes" :key="index">
                        <p>{{ $t('message.usuario') }}: {{ imagen.usuario !== undefined && imagen.usuario !== null?imagen.usuario.nombre_usuario:'-' }}</p>
                        <img @click="verImagen(imagen)" class="img-container" :src="imagen.url" :alt="imagen.url">
                        <div class="form-group">
                            <div :tooltip="imagen.url_publica">
                                <input-field  :id="'link' + title + index" v-model="imagen.url_publica" readonly></input-field>
                            </div>
                            <a :href="imagen.url_publica" download class="btn-success btn--text"><i class="fa fa-download"></i></a>
                            <button @click="copiarLink(imagen.url_publica)" class="btn-secondary btn--text"><i class="fa fa-clone"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        title : {
            type : String,
            required : true
        },
        imagenes : {
            type : Array,
            required : true
        }
    },
    data : function () {
        return {
            url : url,
            ploma : []
        };
    },
    methods : {
        verImagen : function (imagen) {
            this.$emit('verImagen', imagen);
        },
        copiarLinks : function () {
            let urls = '';
            for (let i = 0; i < this.imagenes.length; i++)
                urls += (i === 0?'':',') + this.imagenes[i].url_publica;
            this.copiarLink(urls);
        },
        copiarLink : function (url) {
            let temp = document.createElement('input');
            document.body.appendChild(temp)
            temp.value = url;
            temp.select();
            document.execCommand("copy");
            temp.remove();
        },
        descargarGrupo : function () {
            let that = this;
            let imagenes = [];
            this.imagenes.forEach(function (item) {
                imagenes.push(item.path);
            });
            axios.post(this.url +  '/contenedores/descargar', {
                imagenes : imagenes
            }).then(function (response) {
                location.href = response.data;
            }).catch(function (error) {
                swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
            });
        },
        copiar : function () {
            let that = this;
            let imagenes = [];
            this.imagenes.forEach(function (item) {
                imagenes.push(item.path);
            });
            axios.post(this.url +  '/contenedores/descargar', {
                imagenes : imagenes
            }).then(function (response) {
                window.open(response.data, '_blank');
            }).catch(function (error) {
                swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
            });
        }
    }
}
</script>
<style>
    .img-container {
        width: 100%;
        max-height: 150px;
        height: 150px;
    }
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/ItemGrupoContenedor.vue